import { render } from "./Accompagnement.vue?vue&type=template&id=adb12b54&functionnal=true"
import script from "./Accompagnement.vue?vue&type=script&lang=js"
export * from "./Accompagnement.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.35_vue@3.5.35_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__